import React, { Component } from 'react';

import Styled from './styles';

class Home extends Component {
  render() {
    return (
      <Styled.Container>
        <h1>Home</h1>
      </Styled.Container>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home/index.js